import type { HTMLAttributes, TableHTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react'

import styles from './Table.module.css'

export function Table({ className = '', ...props }: TableHTMLAttributes<HTMLTableElement>) {
  return <table className={`${styles.table} ${className}`} {...props} />
}

export function TableHead(props: HTMLAttributes<HTMLTableSectionElement>) {
  return <thead {...props} />
}

export function TableBody(props: HTMLAttributes<HTMLTableSectionElement>) {
  return <tbody {...props} />
}

export interface TableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  clickable?: boolean
  hovered?: boolean
}

export function TableRow({ clickable = false, hovered = false, className = '', ...props }: TableRowProps) {
  return <tr className={`${clickable ? styles.clickable : ''} ${hovered ? styles.hovered : ''} ${className}`} {...props} />
}

export function TableHeader(props: ThHTMLAttributes<HTMLTableCellElement>) {
  return <th {...props} />
}

export interface TableCellProps extends TdHTMLAttributes<HTMLTableCellElement> {
  numeric?: boolean
}

export function TableCell({ numeric = false, className = '', ...props }: TableCellProps) {
  return <td className={`${numeric ? styles.number : ''} ${className}`} {...props} />
}
